<template>
  <div class="fill-height">
    <v-snackbar
      v-model="dialog.snackbar"
      top
      right
      color="#ff64ad">
      <span class="body-1 font-weight-light white--text"
        v-html="message.success">
      </span>

      <template v-slot:action="{ attrs }">
        <v-btn
          class="body-1 font-weight-bold text-capitalize"
          color="white"
          icon
          v-bind="attrs"
          @click="dialog.snackbar = false">
          <v-icon>mdi-close-circle-outline</v-icon>
        </v-btn>
      </template>
    </v-snackbar>

    <v-dialog v-model="dialog.form"
      @keydown.esc="dialog.form = false"
      :fullscreen="dialog.fullscreen"
      width="1000"
      persistent
      scrollable>
      <v-card class="border-radius pa-2">
        <v-card-title class="d-flex align-center py-0 px-3 text-right popup-header">
          <v-avatar size="35">
            <v-img
              contain
              width="30"
              height="30"
              alt="vuetify"
              :src="require('@/assets/logo/favicon.png')">
              <template v-slot:placeholder>
                <v-row
                  class="fill-height"
                  align="center"
                  justify="center">
                  <v-progress-circular 
                    indeterminate 
                    color="#ff64ad">
                  </v-progress-circular>
                </v-row>
              </template>
            </v-img>
          </v-avatar>

          <span class="mt-1 ml-1">
            {{ form.id.length > 0 ? 'Ubah' : 'Tambah' }} Admin
          </span>

          <v-spacer/>

          <v-icon 
            @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
            class="cursor-pointer mr-1"
            size="24"
            color="#ff64ad">
            {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
          </v-icon>

          <v-icon 
            @click="dialog.form = false"
            class="cursor-pointer"
            size="24"
            color="red">
            mdi-close-circle-outline
          </v-icon>
        </v-card-title>

        <v-divider class="mx-4 mt-3 mb-2"/>

        <v-card-text 
          class="pt-2 body-1 line-text-second">
          <ValidationObserver ref="form">
            <v-form class="text-left">
              <v-row>
                <v-col
                  cols="12"
                  md="3">
                  <uploadfolder v-model="upload.folder"
                    style="position: sticky; top: 0;">
                    <div slot="activator" class="cursor-pointer">
                      <v-card 
                        flat
                        :height="!dialog.fullscreen ? 200 : 350"
                        class="d-flex align-center justify-center"
                        style="border-radius: 15px;
                              border: 2px solid #eaeaea; 
                              border-style: dashed;">
                        <v-img v-if="!process.image && form.image !== ''"
                          alt="kominfo" 
                          width="100%"
                          :height="!dialog.fullscreen ? 195 : 345"
                          gradient="to bottom, rgba(0, 0, 0, .1), rgba(0, 0, 0, .5)"
                          :src="form.image"
                          class="ma-auto d-flex align-center text-center">
                          <template v-slot:placeholder>
                            <v-row
                              class="fill-height"
                              align="center"
                              justify="center">
                              <v-progress-circular 
                                indeterminate 
                                color="#ff64ad">
                              </v-progress-circular>
                            </v-row>
                          </template>

                          <v-icon 
                            size="65" 
                            color="white">
                            mdi-cloud-upload-outline
                          </v-icon>
                        </v-img>

                        <v-icon v-if="!process.image && form.image === ''"
                          size="65" 
                          color="grey">
                          mdi-cloud-upload-outline
                        </v-icon>

                        <v-progress-circular v-if="process.image"
                          indeterminate
                          color="#ff64ad">
                        </v-progress-circular>
                      </v-card>
                    </div>
                  </uploadfolder>
                </v-col>

                <v-col
                  cols="12"
                  md="9">
                  <div
                    class="mb-6">
                    <ValidationProvider 
                      name="role_id" 
                      rules="required" 
                      v-slot="{ errors, valid }">
                      <div class="body-2 mb-2">
                        <span class="red--text">*</span>
                        Role
                        <span class="error--text">
                          (wajib diisi)
                        </span>
                      </div>

                      <v-autocomplete
                        v-on:keyup.enter="save"
                        style="max-width: 50%;"
                        dense
                        outlined
                        color="#ff64ad"
                        hide-details
                        placeholder="Contoh. Capil"

                        :search-input.sync="autocomplete.role"
                        :loading="process.role"
                        
                        :items="list.role"
                        item-value="admin_role_id"
                        item-text="admin_role_name"
                        item-color="#ff64ad"

                        v-model="form.role_id"
                        :success="form.role_id !== '' && valid"
                        :error-messages="errors"
                        required>
                        <template v-slot:append-outer>
                          <div v-if="errors.length > 0">
                            <v-tooltip top color="#ff5252">
                              <template v-slot:activator="{ on }">
                                <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                              </template>
                              
                              Role {{ errors[0] }}
                            </v-tooltip>
                          </div>

                          <div v-if="form.role_id !== '' && valid">
                            <v-icon color="success">mdi-check-circle-outline</v-icon>
                          </div>
                        </template>
                      </v-autocomplete>
                    </ValidationProvider>
                  </div>

                  <ValidationProvider 
                    name="fullname" 
                    rules="required" 
                    v-slot="{ errors, valid }">
                    <div class="body-2 mb-2">
                      <span class="red--text">*</span>
                      Nama Lengkap
                      <span class="error--text">
                        (wajib diisi)
                      </span>
                    </div>
                    
                    <v-text-field
                      v-on:keyup.enter="save"
                      style="max-width: 70%;"
                      dense
                      outlined
                      color="#ff64ad"
                      hide-details
                      placeholder="Contoh. Firmansyah Abdul Rafi"
                      
                      v-model="form.fullname"
                      v-uppercase
                      :success="form.fullname !== '' && valid"
                      :error-messages="errors"
                      required>
                      <template v-slot:append-outer>
                        <div v-if="errors.length > 0">
                          <v-tooltip top color="#ff5252">
                            <template v-slot:activator="{ on }">
                              <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                            </template>
                            
                            Nama Lengkap {{ errors[0] }}
                          </v-tooltip>
                        </div>

                        <div v-if="form.fullname !== '' && valid">
                          <v-icon color="success">mdi-check-circle-outline</v-icon>
                        </div>
                      </template>
                    </v-text-field>
                  </ValidationProvider>

                  <div
                    class="my-6">
                    <div class="body-2 mb-2">
                      KK (Kartu Keluarga)
                      <span>
                        (boleh dikosongi)
                      </span>
                    </div>
                    
                    <v-text-field
                      v-on:keyup.enter="save"
                      style="max-width: 55%;"
                      dense
                      outlined
                      color="#ff64ad"
                      type="number"
                      onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                      min="0"
                      hide-details
                      placeholder="Contoh. 33100062XXXXXXX"
                      
                      v-model="form.kk"
                      v-uppercase
                      :success="form.kk !== ''">
                      <template v-slot:append-outer>
                        <div v-if="form.kk !== ''">
                          <v-icon color="success">mdi-check-circle-outline</v-icon>
                        </div>
                      </template>
                    </v-text-field>
                  </div>

                  <ValidationProvider 
                    name="nik" 
                    rules="required|min:16|max:16" 
                    v-slot="{ errors, valid }">
                    <div class="body-2 mb-2">
                      <span class="red--text">*</span>
                      NIK
                      <span class="error--text">
                        (wajib diisi)
                      </span>
                    </div>
                    
                    <v-text-field
                      v-on:keyup.enter="save"
                      style="max-width: 55%;"
                      dense
                      outlined
                      color="#ff64ad"
                      type="number"
                      onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                      min="0"
                      hide-details
                      placeholder="Contoh. 33100062XXXXXXX"
                      :counter="16"
                      
                      v-model="form.nik"
                      v-uppercase
                      :success="form.nik !== '' && valid"
                      :error-messages="errors"
                      required>
                      <template v-slot:append-outer>
                        <div v-if="errors.length > 0">
                          <v-tooltip top color="#ff5252">
                            <template v-slot:activator="{ on }">
                              <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                            </template>
                            
                            NIK {{ errors[0] }}
                          </v-tooltip>
                        </div>

                        <div v-if="form.nik !== '' && valid">
                          <v-icon color="success">mdi-check-circle-outline</v-icon>
                        </div>
                      </template>
                    </v-text-field>
                  </ValidationProvider>

                  <div
                    class="my-6">
                    <ValidationProvider 
                      name="phone" 
                      rules="required|min:8|max:13"
                      v-slot="{ errors, valid }">
                      <div class="body-2 mb-2">
                        <span class="red--text">*</span>
                        Telepon
                        <span class="error--text">
                          (wajib diisi)
                        </span>
                      </div>
                      
                      <v-text-field
                        v-on:keyup.enter="save"
                        style="max-width: 40%;"
                        type="number"
                        onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                        min="0"
                        dense
                        outlined
                        color="#ff64ad"
                        hide-details
                        placeholder="Contoh. 081332XXXXXX"
                        
                        v-model="form.phone"
                        v-uppercase
                        :success="form.phone !== '' && valid"
                        :error-messages="errors"
                        required>
                        <template v-slot:append-outer>
                          <div v-if="errors.length > 0">
                            <v-tooltip top color="#ff5252">
                              <template v-slot:activator="{ on }">
                                <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                              </template>
                              
                              Telepon {{ errors[0] }}
                            </v-tooltip>
                          </div>

                          <div v-if="form.phone !== '' && valid">
                            <v-icon color="success">mdi-check-circle-outline</v-icon>
                          </div>
                        </template>
                      </v-text-field>
                    </ValidationProvider>
                  </div>

                  <ValidationProvider 
                    name="email" 
                    rules="required|email" 
                    v-slot="{ errors, valid }">
                    <div class="body-2 mb-2">
                      <span class="red--text">*</span>
                      Email
                      <span class="error--text">
                        (wajib diisi)
                      </span>
                    </div>
                    
                    <v-text-field
                      v-on:keyup.enter="save"
                      style="max-width: 45%;"
                      dense
                      outlined
                      color="#ff64ad"
                      hide-details
                      placeholder="Contoh. XXXXX@gmail.com"

                      v-model="form.email"
                      :success="form.email !== '' && valid"
                      :error-messages="errors"
                      required>
                      <template v-slot:append-outer>
                        <div v-if="errors.length > 0">
                          <v-tooltip top color="#ff5252">
                            <template v-slot:activator="{ on }">
                              <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                            </template>
                            
                            Email {{ errors[0] }}
                          </v-tooltip>
                        </div>

                        <div v-if="form.email !== '' && valid">
                          <v-icon color="success">mdi-check-circle-outline</v-icon>
                        </div>
                      </template>
                    </v-text-field>
                  </ValidationProvider>

                  <div
                    class="my-6">
                    <ValidationProvider 
                      name="kecamatan_code" 
                      rules="required" 
                      v-slot="{ errors, valid }">
                      <div class="body-2 mb-2">
                        <span class="red--text">*</span>
                        Kecamatan
                        <span class="error--text">
                          (wajib diisi)
                        </span>
                      </div>

                      <v-autocomplete
                        v-on:keyup.enter="save"
                        style="max-width: 55%;"
                        dense
                        outlined
                        color="#ff64ad"
                        hide-details
                        placeholder="Contoh. Trucuk"

                        :search-input.sync="autocomplete.subdistrict"
                        :loading="process.subdistrict"
                        
                        :items="config.subdistrict"
                        item-value="kecamatan_code"
                        item-text="kecamatan_name"
                        item-color="#ff64ad"

                        v-model="form.kecamatan_code"
                        :success="form.kecamatan_code !== '' && valid"
                        :error-messages="errors"
                        required>
                        <template v-slot:append-outer>
                          <div v-if="errors.length > 0">
                            <v-tooltip top color="#ff5252">
                              <template v-slot:activator="{ on }">
                                <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                              </template>
                              
                              Kecamatan {{ errors[0] }}
                            </v-tooltip>
                          </div>

                          <div v-if="form.kecamatan_code !== '' && valid">
                            <v-icon color="success">mdi-check-circle-outline</v-icon>
                          </div>
                        </template>
                      </v-autocomplete>
                    </ValidationProvider>
                  </div>

                  <ValidationProvider 
                    name="kelurahan_code" 
                    rules="required" 
                    v-slot="{ errors, valid }">
                    <div class="body-2 mb-2">
                      <span class="red--text">*</span>
                      Kelurahan
                      <span class="error--text">
                        (wajib diisi)
                      </span>
                    </div>

                    <v-autocomplete
                      v-on:keyup.enter="save"
                      style="max-width: 55%;"
                      dense
                      outlined
                      color="#ff64ad"
                      hide-details
                      placeholder="Contoh. Kradenan"

                      :search-input.sync="autocomplete.village"
                      :loading="process.village"
                      
                      :items="config.village"
                      item-value="desa_code"
                      item-text="desa_name"
                      item-color="#ff64ad"

                      v-model="form.kelurahan_code"
                      :success="form.kelurahan_code !== '' && valid"
                      :error-messages="errors"
                      required>
                      <template v-slot:append-outer>
                        <div v-if="errors.length > 0">
                          <v-tooltip top color="#ff5252">
                            <template v-slot:activator="{ on }">
                              <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                            </template>
                            
                            Kelurahan {{ errors[0] }}
                          </v-tooltip>
                        </div>

                        <div v-if="form.kelurahan_code !== '' && valid">
                          <v-icon color="success">mdi-check-circle-outline</v-icon>
                        </div>
                      </template>
                    </v-autocomplete>
                  </ValidationProvider>

                  <div
                    class="my-6">
                    <ValidationProvider 
                      name="dukuh" 
                      rules="required" 
                      v-slot="{ errors, valid }">
                      <div class="body-2 mb-2">
                        <span class="red--text">*</span>
                        Dukuh / Dusun
                        <span class="error--text">
                          (wajib diisi)
                        </span>
                      </div>
                      
                      <v-text-field
                        v-on:keyup.enter="save"
                        style="max-width: 60%;"
                        dense
                        outlined
                        color="#ff64ad"
                        hide-details
                        placeholder="Contoh. Kemiri"

                        v-model="form.dukuh"
                        v-uppercase
                        :success="form.dukuh !== '' && valid"
                        :error-messages="errors"
                        required>
                        <template v-slot:append-outer>
                          <div v-if="errors.length > 0">
                            <v-tooltip top color="#ff5252">
                              <template v-slot:activator="{ on }">
                                <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                              </template>
                              
                              Dukuh {{ errors[0] }}
                            </v-tooltip>
                          </div>

                          <div v-if="form.dukuh !== '' && valid">
                            <v-icon color="success">mdi-check-circle-outline</v-icon>
                          </div>
                        </template>
                      </v-text-field>
                    </ValidationProvider>
                  </div>

                  <v-row>
                    <v-col
                      cols="4"
                      class="py-0">
                      <ValidationProvider 
                        name="rt" 
                        rules="required" 
                        v-slot="{ errors, valid }">
                        <div class="body-2 mb-2">
                          <span class="red--text">*</span>
                          RT
                          <span class="error--text">
                            (wajib diisi)
                          </span>
                        </div>
                        
                        <v-text-field
                          v-on:keyup.enter="save"
                          type="number"
                          onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                          min="0"
                          dense
                          outlined
                          color="#ff64ad"
                          hide-details
                          placeholder="Contoh. 22"
                          
                          v-model="form.rt"
                          v-uppercase
                          :success="form.rt !== '' && valid"
                          :error-messages="errors"
                          required>
                          <template v-slot:append-outer>
                            <div v-if="errors.length > 0">
                              <v-tooltip top color="#ff5252">
                                <template v-slot:activator="{ on }">
                                  <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                </template>
                                
                                RT {{ errors[0] }}
                              </v-tooltip>
                            </div>

                            <div v-if="form.rt !== '' && valid">
                              <v-icon color="success">mdi-check-circle-outline</v-icon>
                            </div>
                          </template>
                        </v-text-field>
                      </ValidationProvider>
                    </v-col>

                    <v-col
                      cols="4"
                      class="py-0">
                      <ValidationProvider 
                        name="rw" 
                        rules="required" 
                        v-slot="{ errors, valid }">
                        <div class="body-2 mb-2">
                          <span class="red--text">*</span>
                          RW
                          <span class="error--text">
                            (wajib diisi)
                          </span>
                        </div>
                        
                        <v-text-field
                          v-on:keyup.enter="save"
                          type="number"
                          onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                          min="0"
                          dense
                          outlined
                          color="#ff64ad"
                          hide-details
                          placeholder="Contoh. 10"
                          
                          v-model="form.rw"
                          v-uppercase
                          :success="form.rw !== '' && valid"
                          :error-messages="errors"
                          required>
                          <template v-slot:append-outer>
                            <div v-if="errors.length > 0">
                              <v-tooltip top color="#ff5252">
                                <template v-slot:activator="{ on }">
                                  <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                </template>
                                
                                RW {{ errors[0] }}
                              </v-tooltip>
                            </div>

                            <div v-if="form.rw !== '' && valid">
                              <v-icon color="success">mdi-check-circle-outline</v-icon>
                            </div>
                          </template>
                        </v-text-field>
                      </ValidationProvider>
                    </v-col>
                  </v-row>

                  <div v-if="form.id.length < 1"
                    class="mt-6">
                    <ValidationProvider 
                      name="password" 
                      rules="required|min:5|max:20" 
                      v-slot="{ errors, valid }">
                      <div class="body-2 mb-2">
                        <span class="red--text">*</span>
                        Password
                        <span class="error--text">
                          (wajib diisi)
                        </span>
                      </div>

                      <v-text-field
                        v-on:keyup.enter="save"
                        style="max-width: 45%;"
                        dense
                        outlined
                        color="#ff64ad"
                        hide-details
                        placeholder="Contoh. ******"
                        
                        :type="show ? 'text' : 'password'"
                        :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                        @click:append="show = !show"
                        :counter="20"

                        v-model="form.password"
                        :success="form.password !== '' && valid"
                        :error-messages="errors"
                        required>
                        <template v-slot:append-outer>
                          <div v-if="errors.length > 0">
                            <v-tooltip top color="#ff5252">
                              <template v-slot:activator="{ on }">
                                <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                              </template>
                              
                              Password {{ errors[0] }}
                            </v-tooltip>
                          </div>

                          <div v-if="form.password !== '' && valid">
                            <v-icon color="success">mdi-check-circle-outline</v-icon>
                          </div>
                        </template>
                      </v-text-field>
                    </ValidationProvider>
                  </div>

                  <v-alert 
                    type="error" 
                    text dense prominent 
                    class="mt-8"
                    v-show="message.error.length > 0">
                    {{ message.error }}
                  </v-alert>
                </v-col>
              </v-row>
            </v-form>
          </ValidationObserver>
        </v-card-text>

        <v-divider class="mx-4 mb-3 mt-0"/>

        <v-card-actions>
          <v-spacer/>

          <v-btn
            color="#ff64ad"
            elevation="0"
            class="body-2 font-weight-bold text-capitalize white--text"
            :disabled="process.form"
            :loading="process.form"
            v-on:keyup.enter="save()"
            @click="save()">
            <v-icon small class="mr-1">mdi-check-bold</v-icon>
            Simpan
          </v-btn>

          <v-btn
            outlined
            class="body-2 font-weight-bold text-capitalize red--text"
            :disabled="process.form"
            @click="dialog.form = false">
            <v-icon color="red" small class="mr-1">mdi-close-circle</v-icon>
            Batal
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog.reset"
      @keydown.esc="dialog.reset = false"
      :fullscreen="dialog.fullscreen"
      width="500"
      persistent
      scrollable>
      <v-card class="border-radius pa-2">
        <v-card-title class="d-flex align-center py-0 px-3 text-right popup-header">
          <v-avatar size="35">
            <v-img
              contain
              width="30"
              height="30"
              alt="vuetify"
              :src="require('@/assets/logo/favicon.png')">
              <template v-slot:placeholder>
                <v-row
                  class="fill-height"
                  align="center"
                  justify="center">
                  <v-progress-circular 
                    indeterminate 
                    color="#ff64ad">
                  </v-progress-circular>
                </v-row>
              </template>
            </v-img>
          </v-avatar>

          <span class="mt-1 ml-1">
            Reset Password
          </span>

          <v-spacer/>

          <v-icon 
            @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
            class="cursor-pointer mr-1"
            size="24"
            color="#ff64ad">
            {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
          </v-icon>

          <v-icon 
            @click="dialog.reset = false"
            class="cursor-pointer"
            size="24"
            color="red">
            mdi-close-circle-outline
          </v-icon>
        </v-card-title>

        <v-divider class="mx-4 mt-3 mb-2"/>

        <v-card-text 
          class="pt-2 body-1 line-text-second">
          <ValidationObserver ref="form">
            <v-form class="text-left">
              <div v-if="selected.row.length > 0"
                class="font-weight-light black---text mb-2">
                Apakah Anda yakin mereset password akun <b>{{ selected.row[0].fullname }}</b> ?
              </div>

              <div 
                class="font-italic font-weight-light orange--text">
                *Jika Anda mereset password, maka password akan di default oleh sistem menjadi <b>123456</b>
              </div>
            </v-form>
          </ValidationObserver>
        </v-card-text>

        <v-divider class="mx-4 mb-3 mt-0"/>

        <v-card-actions>
          <v-spacer/>

          <v-btn
            color="#ff64ad"
            elevation="0"
            class="body-2 font-weight-bold text-capitalize white--text"
            :disabled="process.form"
            :loading="process.form"
            v-on:keyup.enter="save()"
            @click="save()">
            <v-icon small class="mr-1">mdi-check-bold</v-icon>
            Simpan
          </v-btn>

          <v-btn
            outlined
            class="body-2 font-weight-bold text-capitalize red--text"
            :disabled="process.form"
            @click="dialog.reset = false">
            <v-icon color="red" small class="mr-1">mdi-close-circle</v-icon>
            Batal
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-layout wrap>
      <v-flex>
        <section>
          <v-card 
            flat 
            style="border: 1px solid #E0E0E0;">
            <v-card-text>
              <v-row>
                <v-col cols="12" md="8" class="d-flex align-center">
                  <!-- ADD -->
                  <div class="mr-3">
                    <v-btn
                      elevation="0"
                      style="background: #00acc133;"
                      class="body-2 text-capitalize font-weight-bold d-flex align-center cyan--text text-darken-1"
                      @click="dialog.form = true; reset();">
                      <v-icon size="18">mdi-plus-circle-outline</v-icon>

                      <span class="ml-1">
                        Tambah Admin
                      </span>
                    </v-btn>
                  </div>

                  <!-- EDIT -->
                  <div class="mr-3" v-if="selected.row.length === 1">
                    <v-btn
                      elevation="0"
                      style="background: #2196f333;"
                      class="body-2 text-capitalize font-weight-bold d-flex align-center blue--text"
                      @click="dialog.form = true; reset(selected.row[0]);">
                      <v-icon size="18">mdi-circle-edit-outline</v-icon>

                      <span class="ml-1">
                        Ubah
                      </span>
                    </v-btn>
                  </div>

                  <!-- RESET PASSWORD -->
                  <div class="mr-3"  v-if="selected.row.length === 1">
                    <v-btn
                      elevation="0"
                      style="background: #ffa50033;"
                      class="body-2 text-capitalize font-weight-bold d-flex align-center orange--text"
                      @click="dialog.reset = true; form.id = selected.row[0].id;">
                      <v-icon size="18">mdi-circle-edit-outline</v-icon>

                      <span class="ml-1">
                        Reset
                      </span>
                    </v-btn>
                  </div>

                  <!-- DETAIL -->
                  <div class="mr-3" v-if="selected.row.length === 1">
                    <v-btn
                      :to="`/admin/${selected.row[0].id}`"
                      elevation="0"
                      style="background: #e0e0e0;"
                      class="body-2 text-capitalize font-weight-bold d-flex align-center text-second">
                      <v-icon size="18">mdi-information-outline</v-icon>

                      <span class="ml-1">
                        Detail
                      </span>
                    </v-btn>
                  </div>
                </v-col>

                <v-col cols="12" md="4" class="d-flex align-center justify-end">
                  <v-text-field 
                    class="mr-3"
                    dense
                    single-line
                    hide-details
                    color="#ff64ad"
                    placeholder="Cari . . ."
                    append-icon="mdi-magnify"
                    clearable
                    v-model="search"
                    v-uppercase
                    @click:clear="search = ''; fetch();"
                    v-on:keyup.enter="fetch()">
                  </v-text-field>
                </v-col>
              </v-row>
            </v-card-text>

            <v-data-table
              v-model="selected.row"
              ref="table-grid"
              class="table-grid"
              :height="`calc(100vh - ${pagination.total_data > 0 ? '330px' : '258px'})`"
              :show-select="true"
              :single-select="true"
              :loading="process.load"
              loading-text="Sedang memuat data . . ."
              loader-height="5"
              no-results-text="Belum ada data"
              :options.sync="options"
              :headers="headers"
              :items="list.data"
              :items-per-page="100"
              item-key="id"
              @click:row="rowClick"
              @toggle-select-all="handleToggleAll($event)"
              hide-default-footer>
              <template v-slot:[`item.index`]="{ index }">
                {{ lastIndex + index }}
              </template>

              <v-progress-linear 
                v-show="process.load" 
                slot="progress" 
                color="white" 
                indeterminate>
              </v-progress-linear>
            </v-data-table>

            <pagination v-if="pagination.total_data > 0"
              @changePage="fetch($event)" 
              @reloadPage="fetch($event)" 
              :model="pagination"/>
          </v-card>
        </section>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import { get, post, put, destroy } from "@/service/Axios";
  export default {
    data () {
      return {
        show: false,
        dialog: {
          fullscreen: false,
          snackbar: false,
          form: false,
          reset: false
        },
        search: '',
        selected: {
          row: []
        },
        options: {},
        headers: [],
        detail: {},
        list: {
          role: [],
          data: []
        },
        limit: 20,
        pagination: {},
        lastIndex: 0,
        autocomplete: {
          role: '',
          subdistrict: '',
          village: ''
        },
        config: {
          subdistrict: [],
          village: []
        },
        upload: {
          folder: null
        },
        form: {
          id: '',

          // ACCOUNT
          fullname: '',
          kk: '',
          nik: '',
          password: '',
          email: '',
          phone: '',
          kecamatan_code: '',
          kecamatan_name: '',
          kelurahan_code: '',
          kelurahan_name: '',
          dukuh: '',
          level: 'operator',
          role_id: '',
          rt: '',
          rw: '',
          image: '',
          extra: {},

          // RESET
          new_password: '123456'
        },
        process: {
          load: false,
          form: false,
          role: false,
          subdistrict: false,
          village: false,
          image: false
        },
        message: {
          success: '',
          error: ''
        }
      }
    },
    components: {
      uploadfolder: () => import(/* webpackPrefetch: true */ '@/components/upload/folder.vue'),
      pagination: () => import(/* webpackPrefetch: true */ '@/components/pagination.vue')
    },
    watch: {
      'upload.folder': {
        handler: function () {
          if (this.upload.folder) {
            this.process.image = this.upload.folder.process

            if (!this.process.image) {
              // CALLBACK FROM UPLOAD IMAGE
              this.form.image = this.upload.folder.data.full.file_url
            }
          }
        },
        deep: true
      },
      'options': {
        handler () {
          let pagination = { row: this.limit, page: 1 }
          this.fetch(pagination)
        },
        deep: true
      },
      'form.kecamatan_code': function() {
        let t = this
        let kec = this.config.subdistrict.filter(function(v) {
          return t.form.kecamatan_code == v.kecamatan_code
        })

        if (kec.length > 0) {
          this.form.kecamatan_name = kec[0].kecamatan_name

          this.form.kelurahan_code = ''
          this.form.kelurahan_name = ''
        }

        this.static().village()
      },
      'form.kelurahan_code': function() {
        let t = this
        let kel = this.config.village.filter(function(v) {
          return t.form.kelurahan_code == v.desa_code
        })

        if (kel.length > 0) {
          this.form.kelurahan_name = kel[0].desa_name
        }
      },
      'autocomplete.role': function() {
        this.fetchRole()
      },
      'autocomplete.subdistrict': function() {
        this.static().subdistrict()
      },
      'autocomplete.village': function() {
        this.static().village()
      }
    },
    computed: {
      user () {
        return this.$store.state.user
      }
    },
    mounted () {
      this.fetch()
    },
    methods: {
      rowClick (item, row) {
        row.select(!row.isSelected ? true : false)
      },
      handleToggleAll (event) {
        if (!event.value) this.selected.row = []
      },
      async fetch (pagination = { row: 20, page: 1 }) {
        this.process.load = true

        this.limit = pagination.row

        let params = {
          limit: pagination.row,
          page: pagination.page,
          sort: this.options.sortBy.length < 1 ? 'id' : this.options.sortBy[0],
          order_by: this.options.sortDesc[0] ? 'ASC' : 'DESC',
          search: this.search
        }

        this.selected.row = []

        await get('user_admin', { params })
        .then(response => {
          let res = response.data

          this.process.load = false
            
          if (res.code === 200) {
            this.headers = [
              {
                text: '#No',
                width: '75px',
                value: 'index',
                sortable: false,
                freeze: true,
                hide: false,
                align: 'center'
              },
              {
                text: 'Nama Lengkap',
                width: '200px',
                value: 'fullname',
                freeze: false,
                hide: false
              },
              {
                text: 'NIK',
                width: '200px',
                value: 'nik',
                freeze: false,
                hide: false
              },
              {
                text: 'KK',
                width: '200px',
                value: 'kk',
                freeze: false,
                hide: false
              },
              {
                text: 'Email',
                width: '100px',
                value: 'email',
                freeze: false,
                hide: false
              },
              {
                text: 'Telepon',
                width: '100px',
                value: 'phone',
                freeze: false,
                hide: false
              }
            ]
            
            this.list.data = res.data
            this.pagination = res.pagination

            this.lastIndex = (pagination.page - 1) * pagination.row 
            this.lastIndex += 1
          }
        })
      },
      async fetchRole () {
        this.process.role = true

        let params = {
          limit: 10000
        }

        await get('user_admin_role', { params })
        .then(response => {
          let res = response.data

          this.process.role = false
            
          if (res.code === 200) {
            this.list.role = res.data
          }
        })
      },
      static () {
        let t = this
        return {
          async subdistrict () {
            t.process.subdistrict = true

            let params = {
              search: t.autocomplete.subdistrict,
              sort: 'DESC'
            }

            await get('location/kecamatan', { params })
            .then(response => {
              let res = response.data
            
              if (res.code === 200) {
                t.process.subdistrict = false

                t.config.subdistrict = res.data
              }
            })
          },
          async village () {
            t.process.village = true

            let params = {
              desa_kecamatan_code: t.form.kecamatan_code,
              search: t.autocomplete.village,
              sort: 'DESC'
            }

            await get('location/desa', { params })
            .then(response => {
              let res = response.data
            
              if (res.code === 200) {
                t.process.village = false

                t.config.village = res.data
              }
            })
          }
        }
      },
      reset (item) {
        if (this.$refs.form) this.$refs.form.reset()
        
        this.form = {
          id: item !== undefined ? item.id : '',

          // ACCOUNT
          fullname: item !== undefined ? item.fullname : '',
          kk: item !== undefined ? item.kk : '',
          nik: item !== undefined ? item.nik : '',
          password: '',
          email: item !== undefined ? item.email : '',
          phone: item !== undefined ? item.phone : '',
          kecamatan_code: item !== undefined ? item.kecamatan_code : '',
          kecamatan_name: item !== undefined ? item.kecamatan_name : '',
          kelurahan_code: item !== undefined ? item.kelurahan_code : '',
          kelurahan_name: item !== undefined ? item.kelurahan_name : '',
          dukuh: item !== undefined ? item.dukuh : '',
          level: item !== undefined ? item.level : 'operator',
          role_id: item !== undefined ? parseInt(item.role_id) : '',
          rt: item !== undefined ? item.rt : '',
          rw: item !== undefined ? item.rw : '',
          image: item !== undefined ? item.image : '',
          extra: item !== undefined ? item.extra : {},

          // RESET
          new_password: '123456'
        }
        
        this.process.form = false

        this.message.error = ''
      },
      async save () {
        this.message.error = ''
        const isValid = await this.$refs.form.validate()

        if (isValid) {
          this.process.form = true

          let url = this.dialog.reset ? 'user_admin/update_password' : this.form.id === '' ? 'user_admin/create' : 'user_admin/update'
          
          // SAVE TO REST API
          await post(url, {
            data: this.form
          })
          .then(response => {
            let res = response.data

            this.process.form = false

            if (res.code === 200) {
              this.dialog.form = false

              this.dialog.reset = false

              this.dialog.snackbar = true

              this.message.success = res.message

              this.fetch()
            } else {
              this.message.error = res.message
            }
          })
        } else {
          // AUTO FOCUS ON TEXT-FIELD
          setTimeout(() => {
            const errors = Object.entries(this.$refs.form.errors)
              .map(([key, value]) => ({ key, value }))
              .filter(error => error['value'].length)
            this.$refs.form.refs[errors[0]['key']].$el.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            })
          }, 10)
        }
      }
    }
  }
</script>